module.exports = "https://static.wanderu.com/static/media/mx.fc15d31a.svg";